/**
 * Feedback Buttons Component
 * Thumbs up and thumbs down buttons for user feedback
 */

import React from 'react';

interface FeedbackButtonsProps {
  hasLastRequest: boolean;
  onThumbsUp: () => void;
  onThumbsDown: () => void;
}

export function FeedbackButtons({
  hasLastRequest,
  onThumbsUp,
  onThumbsDown
}: FeedbackButtonsProps) {
  return (
    <div>
      <span 
        className={`feedback material-symbols-rounded ${!hasLastRequest ? 'disabled' : ''}`}
        onClick={hasLastRequest ? onThumbsUp : undefined}
        title="Positive feedback"
      >
        thumb_up
      </span>
      &nbsp;
      <span 
        className={`feedback material-symbols-rounded ${!hasLastRequest ? 'disabled' : ''}`}
        onClick={hasLastRequest ? onThumbsDown : undefined}
        title="Negative feedback"
      >
        thumb_down
      </span>
    </div>
  );
}

export default FeedbackButtons;
